import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneIcon from '@mui/icons-material/Phone'; // For "Contact Us"
import {  useSelector } from "react-redux";
// material-ui
import { useTheme } from '@mui/material/styles';
import {
    AppBar as MuiAppBar,
    Box,
    Button,
    Container,
    Drawer,
    IconButton,
    Link,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Stack,
    Toolbar,
    Typography,
    useScrollTrigger,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { IconHome2, IconUserPlus } from '@tabler/icons';
import MenuIcon from '@mui/icons-material/Menu';
import LoginIcon from '@mui/icons-material/Login';

import HomeIcon from "assets/images/landing/home.svg"
import DownArrowIcon from "assets/images/landing/downarrow.svg"

import ProfileIcon from './../../assets/images/profile.png'
import ContactIcon from './../../assets/images/contact.png'
import LogoutIcon1 from './../../assets/images/logout1.png'
import LogoutConfirmationPopup from './LogoutPopup';
import { connect } from "react-redux";



function ElevationScroll({ children, window }) {
    const theme = useTheme();
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window
    });
    const darkBorder = theme.palette.mode === 'dark' ? theme.palette.dark.dark : theme.palette.grey[200];

    return React.cloneElement(children, {
        elevation: trigger ? 2 : 0,
        style: {
            backgroundColor: theme.palette.background.default,
            borderBottom: trigger ? 'none' : '1px solid',
            borderColor: trigger ? '' : darkBorder,
            color: theme.palette.text.dark
        }
    });
}

ElevationScroll.propTypes = {
    children: PropTypes.node,
    window: PropTypes.object
};

// ==============================|| MINIMAL LAYOUT APP BAR ||============================== //

const AppBar = ({ ...others }) => {
    const auth = useSelector((state) => state.auth);
    const { isAuthenticated,  user } = auth;
    const [drawerToggle, setDrawerToggle] = React.useState(false);




    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    /** Method called on multiple components with different event types */
    const drawerToggler = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerToggle(open);
    };
    const [open, setOpen] = useState(false)

    const navigate = useNavigate()
    const handleNavigation = (path) => {
        navigate(path);
        setOpen(false);
    };


    const [openPopup, setOpenPopup] = useState(false);

    const handleOpenPopup = () => {
        setOpenPopup(true);
    };

    const handleClosePopup = () => {
        setOpenPopup(false);
    };
    return (<>
        <ElevationScroll {...others}>
            <MuiAppBar>
            <Box
  sx={{
    width: "100%",  // Take up full width
    maxWidth: "1366px",  // Set a fixed maximum width for larger screens
    margin: "0 auto",  // Center the content horizontally
    paddingLeft: "0px", // Apply 20px padding for screens <= 1366px, none for larger screens
    paddingRight: '0px', // Same for the right padding
  }}
>
                <Container style={{
                    maxWidth: "100vw",
                    paddingLeft: "20px",
                    paddingRight: "20px"
                }}>
                    <Toolbar sx={{ paddingX: "0px !important", paddingY: "9px !important" }}>
                        <Box component="div" sx={{ flexGrow: 1, textAlign: 'left' }} >
                            <Typography sx={{ color: "#2D52B2", fontSize: "18px", fontWeight: 700,cursor:"pointer" }} onClick={() => handleNavigation('/')}>
                                Future Veterans<Typography component="span" sx={{ color: "#D52F44", fontSize: "18px", fontWeight: 700, paddingLeft: "5px" }} >TLC</Typography>

                            </Typography>
                            <Typography sx={{ color: "#252525", fontSize: "12px",cursor:"pointer" }}onClick={() => handleNavigation('/')} >

                                Transitioning Lessons & Checklist
                            </Typography>
                        </Box>

                        <Stack direction="row" sx={{ display: { xs: 'none', sm: 'block' }, alignItems: 'center', justifyContent: 'flex-start' }} spacing={2} ref={dropdownRef} >
                            {isAuthenticated ? (
                                <>
                                    {/* Home Icon */}
                                    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                                        <Stack
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            spacing={3} // Spacing between the icons
                                        >
                                            {/* Home Icon */}
                                            <img
                                                src={HomeIcon}
                                                alt="home"
                                                onClick={() => handleNavigation('/')}
                                                style={{ cursor: 'pointer' }}
                                            />

                                            {/* User Icon with Username and Arrow */}
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <img
                                                    src={user?.profile_pic}
                                                    alt="user"
                                                    onClick={() => handleNavigation('/profile')}
                                                    style={{ cursor: 'pointer',borderRadius:"50%",width:"36px",height:"36px" }}
                                                />
                                                <Typography sx={{ color: "#D52F44", fontWeight: 600 ,cursor:"pointer"}}  onClick={() => setOpen(!open)}>Welcome, {user.first_name} {user.last_name}</Typography>
                                                <IconButton onClick={() => setOpen(!open)} sx={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s',marginRight:"-5px !important" }}>
                                                    <img src={DownArrowIcon} alt="arrow" />
                                                </IconButton>
                                            </Stack>
                                        </Stack>
                                    </Box>


                                    {/* List of items */}
                                    {open && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '100%',
                                                right: 0,
                                                backgroundColor: "#FFFF",
                                                padding: 2,
                                                borderRadius: 2,
                                                boxShadow: 2,
                                                width: 'max-content',
                                                zIndex: 5,
                                            }}
                                        >
                                            <Stack spacing={2}>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                    sx={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
                                                    onClick={() => handleNavigation('/profile')}
                                                >
                                                    <img src={ProfileIcon} alt="profile" style={{ width: 15, height: 15 }} />
                                                    <Typography variant="body1">My Profile</Typography>
                                                </Stack>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={() => handleNavigation('/contact')}

                                                >
                                                    <img src={ContactIcon} alt="contact" style={{ width: 15, height: 15 }} />
                                                    <Typography variant="body1">Contact Us</Typography>
                                                </Stack>
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={2}
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={handleOpenPopup}

                                                >
                                                    <img src={LogoutIcon1} alt="logout" style={{ width: 15, height: 15 }} />
                                                    <Typography variant="body1">Logout</Typography>
                                                </Stack>
                                            </Stack>
                                        </Box>
                                    )}
                                </>
                            )
                                : (
                                    <>
                                        <Button to="/register" variant="outlined" sx={{
                                            width: "96px", height: "38px", borderColor: "#D52F44", color: "#D52F44", fontSize: "14px", fontWeight: 500, borderRadius: "10px",
                                            "&:hover": { borderColor: "#D52F44", background: "#fff" }
                                        }} component={RouterLink}>
                                            Sign Up
                                        </Button>
                                        <Button
                                            component={RouterLink}
                                            to="/login"
                                            disableElevation
                                            variant="contained"
                                            sx={{
                                                backgroundColor: "#D52F44", width: "96px", height: "38px", borderRadius: "10px", fontSize: "14px", fontWeight: 500,
                                                "&:hover": { backgroundColor: "#D52F44" }
                                            }}
                                        >
                                            Log In
                                        </Button>
                                    </>
                                )}
                        </Stack>

                        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                            <IconButton color="inherit" onClick={drawerToggler(true)} size="large">
                                <MenuIcon />
                            </IconButton>
                            <Drawer anchor="top" open={drawerToggle} onClose={drawerToggler(false)}>
                                {drawerToggle && (
                                    <Box
                                        sx={{ width: 'auto' }}
                                        role="presentation"
                                        onClick={drawerToggler(false)}
                                        onKeyDown={drawerToggler(false)}
                                    >
                                        <List>
                                            <Link style={{ textDecoration: 'none' }} component={RouterLink} to="/" >
                                                <ListItemButton component="a">
                                                    <ListItemIcon>
                                                        <IconHome2 />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Home" />
                                                </ListItemButton>
                                            </Link>
                                           { isAuthenticated ?
                                           <>
                                            <Link style={{ textDecoration: 'none' }}  component={RouterLink} to="/profile">
                                            <ListItemButton component="a">
                                                <ListItemIcon>
                                                    <PersonOutlineIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="My Profile" />
                                            </ListItemButton>
                                        </Link>
                                      
                                            <ListItemButton component="a"  onClick={handleOpenPopup}>
                                                <ListItemIcon>
                                                    <LogoutIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Logout" />
                                            </ListItemButton>
                                       
                                        </>
                                         : 
                                        <>
                                            <Link style={{ textDecoration: 'none' }}  component={RouterLink} to="/register">
                                                <ListItemButton component="a">
                                                    <ListItemIcon>
                                                        <IconUserPlus />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Sign Up" />
                                                </ListItemButton>
                                            </Link>

                                            <Link style={{ textDecoration: 'none' }}  component={RouterLink} to="/login">
                                                <ListItemButton component="a">
                                                    <ListItemIcon>
                                                        <LoginIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Log In" />
                                                </ListItemButton>
                                            </Link></>}

                                            {/* New Option: My Profile */}
                                           

                                            {/* New Option: Contact Us */}
                                            <Link style={{ textDecoration: 'none' }}  component={RouterLink} to="/contact">
                                                <ListItemButton component="a">
                                                    <ListItemIcon>
                                                        <PhoneIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Contact Us" />
                                                </ListItemButton>
                                            </Link>
                                        </List>
                                    </Box>

                                )}
                            </Drawer>
                        </Box>
                    </Toolbar>
                </Container>
                </Box>
            </MuiAppBar>
        </ElevationScroll>

        <LogoutConfirmationPopup open={openPopup} onClose={handleClosePopup} />
    </>

    );
};

export default AppBar ;
